<template>
    <div v-if="loadedAsset" :style="'background-image: url(' + loadedAsset.url + ');'"></div>
    <div v-else></div>
</template>

<script>
import { isNil } from 'lodash'

import { getAssetById } from '@/plugins/Helpers'

export default {
    name: 'AssetLoader',

    props: {
        asset: {
            type: Object,
            required: true,
        },
        transform: {
            type: String,
            default: '',
            required: false,
        },
    },

    data() {
        return {
            loadedAsset: null,
        }
    },

    watch: {
        asset: {
            async handler(asset) {
                if (!isNil(asset) && asset.asset) {
                    try {
                        const res = await getAssetById(asset.asset, this.transform)
                        this.loadedAsset = res
                    } catch (error) {
                        // console.log(error)
                        this.loadedAsset = false
                    }
                }
            },
            immediate: true,
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
